'use client'
import cn from 'clsx'

import { Swiper, SwiperSlide } from 'swiper/react'
import { A11y } from 'swiper/modules'

import 'swiper/css'

import { ImageBox, Copy } from 'shared-components'

import { useRef, useState, useEffect } from 'react'

import BlockArrow from '../../images/blockArrow'
import diamond from '../../images/diamond'

import s from './ImageSlider.module.sass'

function ImageSlider({ items, breakpoints, showYear, activeIndex, onSlideChange }: any) {
    const sliderRef = useRef<any>(null)

    const [isBeginning, setIsBeginning] = useState(false)
    const [isEnd, setIsEnd] = useState(false)

    if (!items || items.length === 0) {
        return null
    }

    useEffect(() => {
        if (sliderRef.current) {
            sliderRef.current.swiper.slideTo(activeIndex, 500)
        }

        setIsBeginning(sliderRef.current.swiper.isBeginning)
        setIsEnd(sliderRef.current.swiper.isEnd)
    }, [activeIndex])

    const handleClick = (direction: 'next' | 'prev') => () => {
        if (sliderRef.current) {
            if (direction === 'next') {
                sliderRef.current.swiper.slideNext()
            } else {
                sliderRef.current.swiper.slidePrev()
            }
        }
    }

    const handleSlideChange = () => {
        if (sliderRef.current) {
            const swiper = sliderRef.current.swiper
            setIsBeginning(swiper.isBeginning)
            setIsEnd(swiper.isEnd)

            if (onSlideChange) {
                onSlideChange(swiper.realIndex as number)
            }
        }
    }

    return (
        <div className={s.ImageSlider}>
            <Swiper
                ref={sliderRef}
                modules={[A11y]}
                spaceBetween={10}
                slidesPerView={1.2}
                className={s.Slider}
                breakpoints={breakpoints}
                allowTouchMove={true}
                onSlideChange={(swiper) => handleSlideChange()}
            >
                {items.map((item: any, index: number) => {
                    const { image, caption, copy, title, year, objectPosition } = item

                    return (
                        <SwiperSlide key={index}>
                            <div className={s.Slide}>
                                {showYear && year && (
                                    <div className={s.Year}>
                                        <h2
                                            dangerouslySetInnerHTML={{
                                                __html: year,
                                            }}
                                        />
                                        {diamond}
                                    </div>
                                )}
                                <div
                                    className={cn(
                                        s.Image,
                                        objectPosition === 'top' ? s.Top : objectPosition === 'bottom' ? s.Bottom : '',
                                    )}
                                >
                                    {image && <ImageBox image={image} width={600} height={600} />}
                                </div>
                                <div className={s.Content}>
                                    {title && (
                                        <h4
                                            dangerouslySetInnerHTML={{
                                                __html: title,
                                            }}
                                        />
                                    )}

                                    {caption && (
                                        <div className={s.Caption}>
                                            {caption && (
                                                <span
                                                    dangerouslySetInnerHTML={{
                                                        __html: caption,
                                                    }}
                                                />
                                            )}
                                        </div>
                                    )}
                                    {copy && (
                                        <div className={s.Copy}>
                                            <Copy copy={copy} size="small" />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </SwiperSlide>
                    )
                })}
            </Swiper>
            <div className={s.Controls}>
                <button className={isBeginning ? s.Disabled : ''} onClick={handleClick('prev')}>
                    {BlockArrow} <span className={'smallCaps'}>back</span>
                </button>

                <button className={isEnd ? s.Disabled : ''} onClick={handleClick('next')}>
                    <span className={'smallCaps'}>next</span> {BlockArrow}
                </button>
            </div>
        </div>
    )
}

export default ImageSlider
